import React from 'react';
import GitHubCalendar from 'react-github-calendar';
import { Row } from 'react-bootstrap';

const Github = () => {
  return (
    <Row style={{ justifyContent: 'center', paddingBottom: '5px' }}>
      <h1 className="project-heading" style={{ paddingBottom: '10px' }}>
        GitHub
      </h1>
      <p style={{ paddingBottom: '10px' }}>
        Days I <strong className="yellow">Fork</strong>
      </p>
      <GitHubCalendar
        username="harsh774"
        blockSize={15}
        blockMargin={5}
        color="#6102ce"
        fontSize={16}
      />
    </Row>
  );
};

export default Github;
